import { Box } from '@mui/material';
import { GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';

import { useDataGridContext } from '../../hooks/useDataGridContext';
import { getRowId } from '../../util/internalRowIds';
import { AstronautUserAutocomplete } from '~/components/AstronautUserAutocomplete';
import { AstronautAutocompleteValue } from '~/components/AstronautUserAutocomplete/AstonautUserAutocomplete.hook';
import { eventStopPropagation } from '~/util/function/eventStopPropagation';

export interface UserSelectCellContext {
  onUserChange: (rowId: GridRowId, user: AstronautAutocompleteValue) => Promise<void>;
}

export type UserSelectCellValue = AstronautAutocompleteValue;

interface UserSelectCellProps<R extends GridValidRowModel = any> {
  capabilityIds: string[];
  commodityGroupIds: string[];
  value: UserSelectCellValue;
  row: R;
}

export const UserSelectCell = <R extends GridValidRowModel = any>({
  value,
  row,
  capabilityIds,
  commodityGroupIds,
}: UserSelectCellProps<R>) => {
  const { onUserChange } = useDataGridContext<UserSelectCellContext>();
  if (!onUserChange) {
    throw new Error('UserSelectCell: DataGridContextProvider must provide a onUserChange method');
  }

  return (
    <Box
      onClick={eventStopPropagation}
      sx={{
        flex: 1,
      }}
    >
      <AstronautUserAutocomplete
        fullWidth={true}
        size="small"
        value={value || null}
        onChange={(value) => {
          onUserChange(getRowId(row), value);
        }}
        capabilityIds={capabilityIds}
        commodityGroupIds={commodityGroupIds}
      />
    </Box>
  );
};
